// Module
var code = "<div class=\"t-popout c-popout c-popout--basicList c-popoutBasicList\">\n    <div class=\"c-popoutBasicList-items u-p++\">\n        <div ng-bind=\"::context.description\"></div>\n    </div>\n</div>";
// Exports
module.exports = code;